import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastr: ToastrService) { }

  success(message) {
    this.toastr.success(message);
  }

  direct_error(errors){
    this.toastr.error(errors);
  }

  error(errors) {
    errors.forEach(message => {
      this.toastr.error(message);
    });
  }

  getRandomColor() {
    var characters = "0123456789ABCDEF";
    var color = '#';
  
    for (var i = 0; i < 6; i++) {
      color += characters[this.getRandomNumber(0, 15)];
    }
    
    return color;
  }
  
  getRandomNumber(low, high) {
    var r = Math.floor(Math.random() * (high - low + 1)) + low;
    return r;
  }

}
